export default __webpack_public_path__ + "static/media/red-envelope.e4071b1d.svg";